<template>
  <div  class="sign-list">
    <Breadcrumb >
      <BreadcrumbItem>首页</BreadcrumbItem>
      <BreadcrumbItem :to="{name: 'meeting-list'}">活动列表</BreadcrumbItem>
      <BreadcrumbItem>报名管理</BreadcrumbItem>
    </Breadcrumb>
    <div class="single-page ivu-article">
      <h2>{{ meeting.title }}</h2>
      <p>会议开始时间：{{ formatDate(meeting.startDate) }} <br>
        定时发送参会提醒通知：
        <span v-if="meetingNotification.id">
          <span v-if="meetingNotification.hasSent">已于 {{ formatDate(meetingNotification.planSentDate) }} 发送通知。</span>
          <span v-if="!meetingNotification.hasSent">将于 {{ formatDate(meetingNotification.planSentDate) }} 发送通知。</span>
          <Button v-if="meeting.canEdit" size="small" type="warning" @click="showAuditModal(false, 'notification')"><Icon type="md-settings" /> 设置</Button>
          <Button v-if="meeting.canEdit && !meetingNotification.hasSent" size="small" type="error" style="margin-left: 20px" @click="confirmDeleteNotification()"><Icon type="md-close" /> 撤销提醒</Button>
        </span>
        <span v-if="meeting.canEdit && !meetingNotification.id"><Button size="small" type="warning" @click="showAuditModal(false, 'notification')"><Icon type="md-settings" /> 去设置</Button></span>
      </p>
      <Card >
        <p slot="title">
          <Icon type="ios-list-outline"></Icon>
          报名列表
        </p>
        <span slot="extra" class="sign-list-extra">
          <a :href="`/api/admin/meetings/${meetingId}/signAttendees/export`"><Icon type="ios-download-outline"></Icon> 导出全部报名</a>
          <a v-if="meeting.canEdit" style="margin-left: 16px" :href="`/api/admin/meetings/${meetingId}/signAttendees/import/template`"><Icon type="ios-document-outline"></Icon> 下载导入模板</a>
          <Upload
              v-if="meeting.canEdit"
              style="display: inline-block; margin-left: 16px"
              :headers="{Authorization: `Bearer ${token}`}"
              :show-upload-list="false"
              :format="['xls','xlsx']"
              :max-size="10240"
              :on-format-error="handleImportFormatError"
              :on-exceeded-size="handleImportMaxSize"
              :before-upload="beforeImport"
              :on-success="handleImportSuccess"
              :on-error="handleImportError"
              :action="`/api/admin/meetings/${meetingId}/signAttendees/import`">
            <Tooltip content="只能导入基础信息，不会导入自定义报名项；除公司名称外其他列可不填" placement="top">
              <a><Icon type="ios-cloud-upload-outline"></Icon> 导入报名</a>
            </Tooltip>
          </Upload>
        </span>
        <p>
          <Button v-if="meeting.canEdit" type="success" style="margin-right: 10px" @click="showAuditModal(true, 'pass')">批量通过</Button>
          <Button v-if="meeting.canEdit" type="error"  @click="showAuditModal(true, 'refuse')">批量拒绝</Button>
          <!--<Button type="default" style="float:right;margin-left: 5px" @click="exportData(3)"><Icon type="ios-download-outline"></Icon> 导出当前页面数据</Button>-->
          <ButtonGroup style="float:right">
            <Button icon="ios-search" :type="showingStatus === 0 ? 'primary' : 'default'" @click="filterSigns(0)">待审核（<span :style="{color: countWait > 0 ? 'red' : 'inherit'}">{{ countWait }}</span>）</Button>
            <Button icon="ios-search" :type="showingStatus === '' ? 'primary' : 'default'" @click="filterSigns('')">全部（{{ countAll }}）</Button>
            <Button icon="ios-search" :type="showingStatus === 1 ? 'primary' : 'default'" @click="filterSigns(1)">已审核通过（{{ countApproval }}）</Button>
            <Button icon="ios-search" :type="showingStatus === 2 ? 'primary' : 'default'" @click="filterSigns(2)">已审核拒绝（{{ countRefuse }}）</Button>
          </ButtonGroup>
        </p>
        <div>
          <Form ref="formValidate" inline style="margin-bottom: 5px;">
            <FormItem>
              <Input v-model.trim="searchCompanyName" clearable @on-enter="search(1)">
              <span slot="prepend">公司名称</span>
              </Input>
            </FormItem>
            <FormItem>
              <Input v-model.trim="searchPersonName" clearable @on-enter="search(1)">
              <span slot="prepend">姓名</span>
              </Input>
            </FormItem>
            <FormItem>
              <Input v-model.trim="searchMobile" clearable @on-enter="search(1)">
              <span slot="prepend">手机</span>
              </Input>
            </FormItem>
            <FormItem>
              <Input v-model.trim="searchEmail" clearable @on-enter="search(1)">
              <span slot="prepend">邮箱</span>
              </Input>
            </FormItem>
            <FormItem>
              <Button type="primary" @click="search(1)">搜索</Button>
            </FormItem>
          </Form>
        </div>
        <Table :columns="columns" :data="rows" :show-header="true" ref="table" @on-selection-change="handleSelectionChange"></Table>
        <Page :total="totalCount" :page-size="pageSize" :current.sync="currentPage" show-total show-elevator @on-change="handlePageChange" style="margin-top: 10px; text-align: right" />
      </Card>
    </div>
    <Modal
        v-model="showNotificationModal"
        :title="getAuditModalTitle()"
        :mask-closable="false"
        :loading="notificationModalLoading"
        @on-ok="handleNotificationOK()"
        :styles="{top: '10px'}"
        width="700"
    >
      <Form ref="notificationFormValidate"  label-position="top" :model="meetingNotification" :rules="notificationRules">
        <FormItem label="发送参会提醒时间" prop="planSentDate">
          <DatePicker :value="formatDate(meetingNotification.planSentDate)" @on-change="handlePlanSentDateChange"
                      type="datetime" size="large" show-week-numbers placeholder="选择日期和时间"
                      format="yyyy-MM-dd HH:mm" style="width: 100%"></DatePicker>
        </FormItem>
        <FormItem label="通知方式" prop="notificationBy">
          <CheckboxGroup v-model="meetingNotification.notificationBy">
            <Checkbox label="mobile">短信</Checkbox>
            <Checkbox label="email">邮件</Checkbox>
          </CheckboxGroup>
        </FormItem>
        <FormItem v-if="meetingNotification.notificationBy.includes('mobile')" label="短信内容" prop="mobileTextContent" :rules="{required: true, message: '请输入短信内容'}">
          <Alert type="warning">提示：根据工信部及各级运营商的要求，发送的短信需使用通过审核备案的签名。<br>短信内容格式：【云智通信】经贸活动云：xxxxxx。<br>短信总长度不超过70个字。</Alert>
          <Input v-model="meetingNotification.mobileTextContent" type="textarea" :autosize="{minRows: 2,maxRows: 5}" :maxlength="100" placeholder="请输入短信内容"></Input>
        </FormItem>
        <FormItem v-if="meetingNotification.notificationBy.includes('email')"  label="邮件标题" prop="emailTitle" :rules="{required: true, message: '请输入邮件标题'}">
          <Input v-model="meetingNotification.emailTitle" placeholder="请输入邮件标题" style="margin-bottom: 5px"></Input>
        </FormItem>
        <FormItem v-if="meetingNotification.notificationBy.includes('email')"  label="邮件内容" prop="emailContent" :rules="{required: true, message: '请输入邮件内容'}">
          <tinymce v-if="showNotificationModal" id="notificaitonEmailText" v-model.trim="meetingNotification.emailContent" :other_options="tinymceOptions"></tinymce>
        </FormItem>
      </Form>
      <!--<div slot="footer">-->
        <!--<Button type="error" size="large"  @click="resetValidate('notificationFormValidate')">重置</Button>-->
      <!--</div>-->
    </Modal>

    <Modal
        v-model="showModal"
        :title="getAuditModalTitle()"
        :mask-closable="false"
        :loading="modalLoading"
        @on-ok="handleOK()"
        :styles="{top: '10px'}"
        width="700"
    >
      <Form ref="auditFormValidate" label-position="top" :model="notification" :rules="auditRules">
        <FormItem label="通知方式" prop="by">
          <CheckboxGroup v-model="notification.by">
            <Checkbox label="mobile">短信</Checkbox>
            <Checkbox label="email">邮件</Checkbox>
          </CheckboxGroup>
        </FormItem>
        <FormItem v-if="notification.by.includes('mobile')" label="短信内容" prop="mobileText" :rules="{required: true, message: '请输入短信内容'}">
          <Alert type="warning">提示：根据工信部及各级运营商的要求，发送的短信需使用通过审核备案的签名。<br></br>短信内容格式：【云智通信】经贸活动云：xxxxxx。<br>短信总长度不超过70个字。</Alert>
          <Input v-model.trim="notification.mobileText" type="textarea" :autosize="{minRows: 2,maxRows: 5}" :maxlength="100" placeholder="请输入短信内容"></Input>
        </FormItem>
        <FormItem v-if="notification.by.includes('email')"  label="邮件标题" prop="emailTitle"  :rules="{required: true, message: '请输入邮件标题'}">
          <Input v-model.trim="notification.emailTitle" size="large" placeholder="请输入邮件标题" style="margin-bottom: 10px"></Input>
        </FormItem>
        <FormItem v-if="notification.by.includes('email')" prop="emailText" label="邮件内容" :rules="{required: true, message: '请输入邮件内容'}">
          <tinymce v-if="showModal" id="emailText" v-model.trim="notification.emailText" :other_options="tinymceOptions"></tinymce>
        </FormItem>
      </Form>
    </Modal>
  </div>
</template>
<script>

import Vue from 'vue'
import { mapState } from 'vuex'
import moment from 'moment'
import tinymce from './components/TinymceVue'

export default {
  name: 'SignList',
  props: ['meetingId'],
  components: {tinymce},
  data () {
    return {
      totalPage: 1,
      currentPage: 1,
      totalCount: 1,
      pageSize: 30,
      countWait: 0,
      countAll: 0,
      countApproval: 0,
      countRefuse: 0,
      remoteStatus: null,
      signs: [],
      meetingNotification: {notificationBy: ['mobile', 'email']},
      searchCompanyName: null,
      searchPersonName: null,
      searchMobile: null,
      searchEmail: null,
      showingStatus: '',
      showModal: false,
      showNotificationModal: false,
      modalLoading: true,
      notificationModalLoading: true,
      notification: {
        by: ['mobile', 'email'],
        mobileText: '【云智通信】经贸活动云：',
        emailText: '',
        emailTitle: '',
        receivers: [],
        type: 'pass',
        isBatch: false
      },
      notificationText: {
        mobileTextPass: '',
        mobileTextRefuse: '',
        emailTextPass: '',
        emailTextTitlePass: '',
        emailTextRefuse: '',
        emailTextTitleRefuse: ''
      },
      meeting: {signSetting: {
        signMeetingSteps: []
      }},
      tinymceOptions: {
        menubar: 'edit insert view format table tools',
        theme: 'modern',
        height: 150,
        relative_urls: false,
        convert_urls: false,
        images_upload_url: '/api/admin/cms/articles/img/upload',
        images_upload_base_path: '/api/admin/cms/articles/img/show?path=',
        paste_data_images: true,
        branding: false,
        table_default_styles: {
          width: '100%',
          borderCollapse: 'collapse'
        }
      },
      tableLoading: true,
      saving: false,
      selectedSigns: [],
      countOfAllMeetings: 1,
      columnsStart: [
        {
          type: 'selection',
          width: 50,
          fixed: 'left',
          align: 'center'
        },
        {
          title: '报名时间',
          key: 'signDate',
          width: 90
        },
        {
          title: '公司名称',
          key: '公司名称',
          width: 150
        },
        {
          title: '姓名',
          key: '姓名',
          width: 80
        }
      ],
      columnsEnd: [
        {
          title: '报名数 / 总活动数',
          key: 'countOfAttending',
          width: 70,
          fixed: 'right',
          align: 'center',
          render: (h, params) => {
            return h('span', `${params.row.countOfAttending} / ${this.countOfAllMeetings}`)
          }
        },
        {
          title: '审核状态',
          key: 'auditStatus',
          width: 70,
          fixed: 'right'
        },
        {
          title: '操作',
          width: 100,
          fixed: 'right',
          key: 'operation',
          render: (h, params) => {
            let elements = []
            if (this.meeting.canEdit && params.row.signStatus === 0) {
              elements.push(
                h('p', [ h('Button', {
                  props: {
                    type: 'success',
                    size: 'small'
                  },
                  on: {
                    click: () => {
                      this.showAuditModal(false, 'pass', params.row.id)
                    }
                  }
                }, '审核通过')])
              )
              elements.push(h('p', [
                h('Button', {
                  props: {
                    type: 'error',
                    size: 'small'
                  },
                  on: {
                    click: () => {
                      this.showAuditModal(false, 'refuse', params.row.id)
                    }
                  }
                }, '审核拒绝')])
              )
            }
            elements.push(
              h('p', [ h('Button', {
                props: {
                  type: 'default',
                  size: 'small'
                },
                on: {
                  click: () => {
                    this.$router.push(`/meetings/${this.meetingId}/signs/${params.row.id}`)
                  }
                }
              }, '查看详情')])
            )
            return h('div', elements)
          }
        }
      ],
      auditRules: {
        by: [
          {required: false, message: '请选择一种通知方式'}
        ]
      },
      notificationRules: {
        planSentDate: [
          {required: true, message: '请选择发送时间'}
        ],
        notificationBy: [
          {required: true, message: '请至少选择一种通知方式'}
        ]
      }
    }
  },
  computed: {
    ...mapState([
      'token'
    ]),
    columns () {
      let signColumns = this.getMeetingColumns()
      return [...this.columnsStart, ...signColumns, ...this.columnsEnd]
    },
    rows () {
      return this.signs.map((item, index) => {
        let jsonData = JSON.parse(item.data)
        const getDisplayValue = value => {
          if (value === null || value === undefined) {
            return ''
          }
          return String(value).trim().toLowerCase() === 'null' ? '' : value
        }
        const contactPhone = getDisplayValue(item.contactPhone)
        const mobile = getDisplayValue(jsonData['手机'])
        jsonData.contactPhone = contactPhone ? contactPhone + '\t' : ''
        jsonData.contactEmail = getDisplayValue(item.contactEmail)
        return {
          ...jsonData,
          companyName: getDisplayValue(jsonData['公司名称']),
          name: getDisplayValue(jsonData['姓名']),
          mobile: mobile ? mobile + '\t' : '',
          '手机': mobile ? mobile + '\t' : '',
          email: getDisplayValue(jsonData['邮箱']),
          '护照/身份证号': getDisplayValue(jsonData['护照/身份证号']) ? getDisplayValue(jsonData['护照/身份证号']) + '\t' : '',
          signDate: this.formatDate(item.createDate).toString(),
          auditStatus: this.getStatusText(item.signStatus),
          hasSignInText: item.hasSignIn ? '已签到' : '未签到',
          hasSignIn: item.hasSignIn,
          signStatus: item.signStatus,
          id: item.id,
          countOfAttending: item.countOfAttending,
          index: index + 1
        }
      })
    },
    exportColumns () {
      return this.columns.filter((col, index) => {
        return index < this.columns.length - 3 && index > 0
      })
    }
  },
  methods: {
    setCounts (result) {
      this.countWait = result.countOfStatusCreated
      this.countAll = result.countOfAll
      this.countApproval = result.countOfStatusPass
      this.countRefuse = result.countOfStatusRefuse
    },
    setSigns (result) {
      this.signs = result.signs
      this.totalPage = result.totalPage
      this.totalCount = result.totalCount
    },
    async handlePageChange (currentPage) {
      this.currentPage = currentPage
      this.search(this.currentPage)
    },
    getMeetingNotification () {
      let meetingNotification = JSON.parse(JSON.stringify(this.meetingNotification))
      meetingNotification.notificationBy = JSON.stringify(this.meetingNotification.notificationBy)
      return meetingNotification
    },
    setMeetingNotification (meetingNotification) {
      console.log(meetingNotification)
      if (meetingNotification && meetingNotification.notificationBy) {
        meetingNotification.notificationBy = JSON.parse(meetingNotification.notificationBy)
        this.meetingNotification = meetingNotification
      } else {
        this.meetingNotification = {notificationBy: ['mobile', 'email'], mobileTextContent: '【云智通信】经贸活动云：'}
      }
    },
    handlePlanSentDateChange (date) {
      console.log(date)
      if (date) {
        Vue.set(this.meetingNotification, 'planSentDate', new Date(date))
      } else {
        Vue.set(this.meetingNotification, 'planSentDate', '')
      }
    },
    confirmDeleteNotification () {
      this.$Modal.confirm({
        title: '确认撤销提醒通知吗？',
        content: '',
        onOk: () => {
          this.deleteNotification()
        }
      })
    },
    setMessages (messages) {
      this.notificationText.mobileTextPass = messages['mobilePassText']
      this.notificationText.mobileTextRefuse = messages['mobileRefuseText']
      this.notificationText.emailTextPass = messages['emailPassText']
      this.notificationText.emailTextTitlePass = messages['emailPassTextTitle']
      this.notificationText.emailTextRefuse = messages['emailRefuseText']
      this.notificationText.emailTextTitleRefuse = messages['emailRefuseTextTitle']
    },
    getAuditModalTitle () {
      if (this.notification.isBatch) {
        if (this.notification.type === 'pass') {
          return `审核通过${this.notification.receivers.length}人并发送通知`
        } else if (this.notification.type === 'refuse') {
          return `审核拒绝${this.notification.receivers.length}人并发送通知`
        }
      } else {
        if (this.notification.type === 'pass') {
          return `审核通过并发送通知`
        } else if (this.notification.type === 'refuse') {
          return `审核拒绝并发送通知`
        } else if (this.notification.type === 'notification') {
          return '请设定参会提醒发送时间、通知方式和通知内容，系统会自动在指定时间给审核通过的报名人发送通知'
        }
      }
    },
    handleOK () {
      let validPass = false
      this.$refs['auditFormValidate'].validate((valid) => {
        if (valid) {
          validPass = true
        } else {
          validPass = false
        }
      })

      if (!validPass) {
        this.modalLoading = false
        this.$nextTick(() => {
          this.modalLoading = true
        })
        return
      }

      if (this.notification.isBatch) {
        if (this.notification.type === 'pass') {
          this.batchAuditPass()
        } else if (this.notification.type === 'refuse') {
          this.batchAuditRefuse()
        }
      } else {
        if (this.notification.type === 'pass') {
          this.auditPass(this.notification.receivers[0])
        } else if (this.notification.type === 'refuse') {
          this.auditRefuse(this.notification.receivers[0])
        }
      }
      this.showModal = false
    },
    handleNotificationOK () {
      let validPass = false
      this.$refs['notificationFormValidate'].validate((valid) => {
        if (valid) {
          validPass = true
        } else {
          validPass = false
        }
      })

      if (!validPass) {
        console.log(validPass)

        this.notificationModalLoading = false
        this.$nextTick(() => {
          this.notificationModalLoading = true
        })
        return
      }

      this.sendNotification()
      this.showNotificationModal = false
    },
    async sendNotification () {
      try {
        this.beforeSave()
        if (this.meetingNotification.id && !this.meetingNotification.hasSent) {
          this.setMeetingNotification((await this.$http.put(`/api/admin/meetings/${this.meetingId}/notification`, this.getMeetingNotification())).body)
        } else {
          this.setMeetingNotification((await this.$http.post(`/api/admin/meetings/${this.meetingId}/notification`, this.getMeetingNotification())).body)
        }
        this.afterSave()
      } catch (e) {
        this.afterSave(e)
      }
    },
    async deleteNotification () {
      try {
        this.beforeSave()
        if (this.meetingNotification.id && !this.meetingNotification.hasSent) {
          this.setMeetingNotification((await this.$http.delete(`/api/admin/meetings/${this.meetingId}/notification/${this.meetingNotification.id}`)).body)
        }
        this.afterSave()
      } catch (e) {
        this.afterSave(e)
      }
    },
    showAuditModal (isBatch, type, signId) {
      this.notification.type = type
      this.notification.isBatch = isBatch
      if (isBatch) {
        if (this.selectedSigns.length === 0) {
          this.$Modal.error({
            title: '请至少选择一个报名',
            content: ''
          })
          return
        }

        this.notification.receivers = this.selectedSigns.map(item => {
          return item.id
        })
      } else {
        this.notification.receivers = [signId]
      }

      if (type === 'pass') {
        this.notification.mobileText = this.notificationText.mobileTextPass || '【云智通信】经贸活动云：'
        this.notification.emailText = this.notificationText.emailTextPass
        this.notification.emailTitle = this.notificationText.emailTextTitlePass
        this.showModal = true
      } else if (type === 'refuse') {
        this.notification.mobileText = this.notificationText.mobileTextRefuse || '【云智通信】经贸活动云：'
        this.notification.emailText = this.notificationText.emailTextRefuse
        this.notification.emailTitle = this.notificationText.emailTextTitleRefuse
        this.showModal = true
      } else if (type === 'notification') {
        this.notification.mobileText = '【云智通信】经贸活动云：'
        this.notification.emailText = ''
        this.notification.emailTitle = ''
        this.showNotificationModal = true
      }
    },
    async batchAuditPass () {
      if (this.selectedSigns.length === 0) {
        this.$Modal.error({
          title: '请至少选择一个报名',
          content: ''
        })
        return
      }

      let signIdList = this.selectedSigns.map(item => {
        return item.id
      })

      try {
        this.beforeSave()
        await this.$http.put(`/api/admin/meetings/${this.meetingId}/signAttendees/{id}/batch/audit/pass`, {signIdList: signIdList, notification: this.notification})
        let messages = (await Vue.http.get(`/api/admin/meetings/${this.meetingId}/notification/messages`)).body
        this.setMessages(messages)
        this.search(this.currentPage)

        this.afterSave()
      } catch (e) {
        this.afterSave(e)
      }
    },
    async batchAuditRefuse () {
      if (this.selectedSigns.length === 0) {
        this.$Modal.error({
          title: '请至少选择一个报名',
          content: ''
        })
        return
      }

      let signIdList = this.selectedSigns.map(item => {
        return item.id
      })

      try {
        this.beforeSave()
        await this.$http.put(`/api/admin/meetings/${this.meetingId}/signAttendees/{id}/batch/audit/refuse`, {signIdList: signIdList, notification: this.notification})
        let messages = (await Vue.http.get(`/api/admin/meetings/${this.meetingId}/notification/messages`)).body
        this.setMessages(messages)
        this.search(this.currentPage)

        this.afterSave()
      } catch (e) {
        this.afterSave(e)
      }
    },
    handleSelectionChange (selection) {
      this.selectedSigns = selection
    },
    filterSigns (status) {
      this.showingStatus = status
      this.search(1)
    },
    getMeetingColumns () {
      let columns = []
      this.meeting.signSetting.signMeetingSteps.forEach(step => {
        step.componentList.forEach(component => {
          // 公司名称, 姓名
          if (component.signFormComponent.id !== 101 &&
              component.signFormComponent.id !== 2) {
            if (component.signFormComponent.type === 'uploadImg') {
              columns.push({
                title: component.signFormComponent.label,
                key: component.signFormComponent.label,
                width: 150,
                render: (h, params) => {
                  let path = params.row[component.signFormComponent.label]
                  if (path) {
                    return h('img', {
                      attrs: {
                        height: 80,
                        src: `/api/admin/meetings/cover/show?path=${params.row[component.signFormComponent.label]}.bizThumbnail.png`
                      },
                      style: {
                        'vertical-align': 'middle'
                      }
                    })
                  } else {
                    return h('span', '未上传')
                  }
                }
              })
            } else if (component.signFormComponent.type === 'uploadConfigImg') {
              columns.push({
                title: component.signFormComponent.label,
                key: component.signFormComponent.label,
                width: 150,
                render: (h, params) => {
                  let fileInfoJson = params.row[component.signFormComponent.label]
                  let fileInfo = null
                  if (fileInfoJson) {
                    try {
                      fileInfo = JSON.parse(fileInfoJson)[0]
                    } catch (e) {
                      fileInfo = null
                    }
                  }
                  if (fileInfo && fileInfo.mediaLink) {
                    return h('img', {
                      attrs: {
                        height: 80,
                        src: `/api/admin/meetings/cover/show?path=${fileInfo.mediaLink}.bizThumbnail.png`
                      },
                      style: {
                        'vertical-align': 'middle'
                      }
                    })
                  } else {
                    return h('span', '未上传')
                  }
                }
              })
            } else {
              columns.push({
                title: component.signFormComponent.label,
                key: component.signFormComponent.label,
                tooltip: true,
                width: 100
              })
            }
          }
        })
      })
      columns.push({
        title: '联系人电话',
        key: 'contactPhone',
        width: 100
      })
      columns.push({
        title: '联系人邮箱',
        key: 'contactEmail',
        width: 100
      })

      return columns
    },
    exportData (type) {
      if (type === 1) {
        this.$refs.table.exportCsv({
          filename: `${this.meeting.title}_报名表`
        })
      } else if (type === 2) {
        this.$refs.table.exportCsv({
          filename: `${this.meeting.title}_报名表`,
          original: false
        })
      } else if (type === 3) {
        this.$refs.table.exportCsv({
          filename: `${this.meeting.title}_报名表`,
          columns: this.exportColumns,
          quoted: true,
          data: this.rows
        })
      }
    },
    isNumber (n) {
      return !isNaN(parseFloat(n)) && isFinite(n)
      // return typeof n ==='number' && isFinite(n)
    },
    getStatusText (status) {
      if (status === 0) {
        return '待审核'
      } else if (status === 1) {
        return '审核通过'
      } else if (status === 2) {
        return '审核拒绝'
      }

      return ''
    },
    formatDate (timestamp) {
      if (timestamp) {
        return moment(timestamp).format('YYYY-MM-DD HH:mm:ss')
      } else {
        return null
      }
    },
    beforeSave () {
      this.$Message.destroy()
      this.$Loading.start()
      this.saving = true
    },
    afterSave (e) {
      this.$Loading.finish()
      if (e) {
        this.$Message.error({
          content: e.body.error || '操作失败，请重试',
          duration: 0,
          closable: true
        })
      } else {
        this.$Message.success('操作成功！')
      }
      this.saving = false
    },
    beforeImport () {
      this.$Message.destroy()
      this.$Loading.start()
      return true
    },
    async handleImportSuccess (response) {
      this.$Loading.finish()
      let title = `导入完成：成功${response.successCount || 0}条，失败${response.failureCount || 0}条`
      if (response.failureCount > 0) {
        let errors = (response.errors || []).slice(0, 10).map(item => {
          return `第${item.rowNumber}行：${item.reason}`
        }).join('<br>')
        if (response.errors && response.errors.length > 10) {
          errors += '<br>更多错误请修正后再次导入。'
        }
        this.$Modal.warning({
          title: title,
          content: errors
        })
      } else {
        this.$Message.success(title)
      }
      this.currentPage = 1
      try {
        await this.search(1)
      } catch (e) {
        this.$Message.warning('导入已完成，但刷新列表失败，请手动刷新页面查看最新数据')
      }
    },
    handleImportError (error, response) {
      this.$Loading.finish()
      let errorMessage = '导入失败，请重试'
      const parseResponse = (payload) => {
        if (!payload) {
          return null
        }
        try {
          return typeof payload === 'string' ? JSON.parse(payload) : payload
        } catch (e) {
          return payload
        }
      }
      const body = parseResponse(response) ||
        parseResponse(error && error.response) ||
        parseResponse(error && error.target && error.target.response) ||
        parseResponse(error && error.xhr && (error.xhr.responseText || error.xhr.response))
      if (body && body.error) {
        errorMessage = body.error
      } else if (typeof body === 'string' && body) {
        errorMessage = body
      } else if (error && error.message) {
        try {
          errorMessage = error.message
        } catch (e) {}
      }
      this.$Message.error({
        content: errorMessage,
        duration: 0,
        closable: true
      })
    },
    handleImportFormatError () {
      this.$Message.error('请上传xls或xlsx格式的Excel文件')
    },
    handleImportMaxSize () {
      this.$Message.error('Excel文件大小不能超过10M')
    },
    promptAuditPass (signId) {
      this.$Modal.confirm({
        title: '确认审核通过吗？',
        okText: '审核通过',
        cancelText: '取消',
        onOk: () => {
          this.auditPass(signId)
        }
      })
    },
    promptAuditRefuse (signId) {
      this.$Modal.confirm({
        title: '确认审核拒绝吗？',
        okText: '审核拒绝',
        cancelText: '取消',
        onOk: () => {
          this.auditRefuse(signId)
        }
      })
    },
    updateSignStatus (signId, status) {
      let sign = this.signs.find(item => {
        return item.id === signId
      })

      if (sign) {
        sign.signStatus = status
      }
    },
    async signIn (signId) {
      try {
        this.beforeSave()
        let updatedSign = (await this.$http.put(`/api/admin/meetings/${this.meetingId}/signs/${signId}/signIn`)).body
        this.afterSave()
        let matchedIndex = -1
        this.signs.forEach((item, index) => {
          if (item.id === signId) {
            matchedIndex = index
          }
        })
        if (matchedIndex !== -1) {
          this.signs.splice(matchedIndex, 1, updatedSign)
        }
      } catch (e) {
        this.afterSave(e)
      }
    },
    async auditPass (signAttendeeId) {
      try {
        this.beforeSave()
        await this.$http.put(`/api/admin/meetings/${this.meetingId}/signAttendees/${signAttendeeId}/audit/pass`, {notification: this.notification})
        this.search(this.currentPage)
        this.afterSave()

        if (this.notification.by.includes('mobile')) {
          this.notificationText.mobileTextPass = this.notification.mobileText
        } else if (this.notification.by.includes('email')) {
          this.notificationText.emailTextPass = this.notification.emailText
          this.notificationText.emailTextTitlePass = this.notification.emailTitle
        }
      } catch (e) {
        this.afterSave(e)
      }
    },
    async auditRefuse (signId) {
      try {
        this.beforeSave()
        await this.$http.put(`/api/admin/meetings/${this.meetingId}/signAttendees/${signId}/audit/refuse`, {notification: this.notification, refuseReason: '默认'})
        this.search(this.currentPage)
        this.afterSave()

        if (this.notification.by.includes('mobile')) {
          this.notificationText.mobileTextRefuse = this.notification.mobileText
        } else if (this.notification.by.includes('email')) {
          this.notificationText.emailTextRefuse = this.notification.emailText
          this.notificationText.emailTextTitleRefuse = this.notification.emailTitle
        }
      } catch (e) {
        this.afterSave(e)
      }
    },
    async search (startPage) {
      try {
        this.$Loading.start()
        let queryStr = `page=${startPage}&size=${this.pageSize}&status=${this.showingStatus}`
        if (this.searchCompanyName && this.searchCompanyName !== '') {
          queryStr += `&companyName=${this.searchCompanyName}`
        }
        if (this.searchPersonName && this.searchPersonName !== '') {
          queryStr += `&personName=${this.searchPersonName}`
        }
        if (this.searchMobile && this.searchMobile !== '') {
          queryStr += `&mobile=${this.searchMobile}`
        }
        if (this.searchEmail && this.searchEmail !== '') {
          queryStr += `&email=${this.searchEmail}`
        }
        this.setSigns((await this.$http.get(`/api/admin/meetings/${this.meetingId}/signAttendees?${queryStr}`)).body)
        let countResp = await Vue.http.get(`/api/admin/meetings/${this.meetingId}/signAttendees/status/count`)
        this.setCounts(countResp.body)

        this.$Loading.finish()
      } catch (e) {
        this.afterSave(e)
      }
    }
  },
  async beforeRouteEnter (to, from, next) {
    try {
      let countMeetingsResp = await Vue.http.get(`/api/admin/meetings/count`)
      let resp = await Vue.http.get(`/api/admin/meetings/${to.params.meetingId}/signAttendees?page=1&size=30`)
      let countResp = await Vue.http.get(`/api/admin/meetings/${to.params.meetingId}/signAttendees/status/count`)

      let meeting = (await Vue.http.get(`/api/admin/meetings/${to.params.meetingId}`)).body
      let messages = (await Vue.http.get(`/api/admin/meetings/${to.params.meetingId}/notification/messages`)).body
      let meetingNotification = (await Vue.http.get(`/api/admin/meetings/${to.params.meetingId}/notification/latest`)).body
      next(vm => {
        vm.remoteStatus = resp.status
        vm.setSigns(resp.body)
        vm.setCounts(countResp.body)
        vm.meeting = meeting
        vm.setMessages(messages)
        vm.setMeetingNotification(meetingNotification)
        vm.countOfAllMeetings = countMeetingsResp.body
      })
    } catch (e) {
      next(vm => {
        vm.remoteStatus = e.status
        vm.signs = []
        vm.meeting = {}
      })
    }
  },
  async beforeRouteUpdate (to, from, next) {
    try {
      let countMeetingsResp = await Vue.http.get(`/api/admin/meetings/count`)
      let resp = await Vue.http.get(`/api/admin/meetings/${this.meetingId}/signAttendees?page=1&size=30`)
      let countResp = await Vue.http.get(`/api/admin/meetings/${to.params.meetingId}/signAttendees/status/count`)

      let meeting = (await Vue.http.get(`/api/admin/meetings/${this.meetingId}`)).body
      let messages = (await Vue.http.get(`/api/admin/meetings/${this.meetingId}/notification/messages`)).body
      let meetingNotification = (await Vue.http.get(`/api/admin/meetings/${this.meetingId}/notification/latest`)).body

      this.remoteStatus = resp.status
      this.setSigns(resp.body)
      this.setCounts(countResp.body)

      this.meeting = meeting
      this.setMessages(messages)
      this.setMeetingNotification(meetingNotification)
      this.countOfAllMeetings = countMeetingsResp.body
      next()
    } catch (e) {
      this.remoteStatus = e.status
      this.signs = []
      this.meeting = {}
      next()
    }
  }
}
</script>

<style>
  .sign-list .ivu-table-cell {
    padding-left: 10px !important;
    padding-right: 10px !important;
  }
  .sign-list .ivu-form-item {
    margin-bottom: 0;
  }
</style>



// WEBPACK FOOTER //
// src/views/meeting/SignList.vue